import tmsApi from './../api/tmsApi';

export default {
  namespaced: true,
  state: {
    preferences: {},
    errors: {
      actions: [],
    },
  },
  mutations: {
    CLEAR_DATA(state) {
      state.preferences = {};
    },
    ADD_DATA(state, data) {
      state.preferences = data;
    },
    ADD_ERROR(state, action) {
      state.errors.actions.push(action);
    },
    REMOVE_ERROR(state, error) {
      const index = state.errors.actions.findIndex(err => err === error);
      state.errors.actions.splice(index, 1);
    },
  },
  getters: {
    widgets(state) {
      const { preferences } = state;
      const hasDashboardProperty = Object.prototype.hasOwnProperty.call(preferences, 'dashboard');
      const widgets = hasDashboardProperty ? preferences.dashboard : [];

      return widgets;
    },
  },
  actions: {
    LOAD_USER_PREFERENCES({ commit, rootState }) {
      const api = tmsApi.buildRetry(rootState.token);
      const { id: userId } = rootState.userData;
      const query = `{
        user(id: ${userId}) {
          preferences
        }
      }`;

      commit('CLEAR_DATA');
      return api(query, 'user_preference').then(({ data }) => {
        const { preferences } = data.user;
        commit('ADD_DATA', preferences);
        return preferences;
      }).catch(() => {
        commit('ADD_ERROR', 'LOAD_USER_PREFERENCES');
      });
    },
    UPDATE_USER_PREFERENCES({ state, commit, rootState }, payloads) {
      const api = tmsApi.build(rootState.token);
      const { dashboard } = payloads;

      const { preferences } = state;
      preferences.dashboard = dashboard;

      const { id } = rootState.userData;
      const input = {
        preference: preferences,
      };

      const variables = {
        id,
        input,
      };

      const query = `
        mutation UpdateUserPreferences($id: ID!, $input: UserUpdateInput) {
          user: update_user(id: $id, input: $input) {
            id
            username
            preferences
          }
        }
      `;

      commit('CLEAR_DATA');
      return api({
        query,
        variables,
      }, 'update_user_preference').catch(() => {
        commit('ADD_ERROR', 'UPDATE_USER_PREFERENCES');
      });
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/dashboard.js